// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { messageServicesKey } from "./constants";
import type { MessagingServicePayload } from "./types";

export const getMessagingServices = reactQueryFetcherAdapter(
  messageServicesKey,
  async (signal, appGroupId: string, limit?: number): Promise<MessagingServicePayload> => {
    return fetch(
      `/engagement/${appGroupId}/sms_messaging_services`,
      "GET",
      { query: null, limit },
      {
        signal,
      }
    );
  }
);
